import * as angular from 'angular';
import * as noUiSlider from 'nouislider';

interface IYearRangeModel {
    start: number;
    end: number;
}

interface IYearRangeScope extends angular.IScope {
    min: number;
    max: number;
    step: number;
    model: IYearRangeModel;
    change: (model: IYearRangeModel) => void;
}

class YearRangeDirective implements angular.IDirective {
    readonly replace = true;
    readonly restrict = 'E';
    readonly scope = {
        min: '=',
        max: '=',
        step: '=',
        model: '=ngModel',
        change: '&ngChange'
    };

    readonly require = 'ngModel';
    readonly template = '<div class="fc-year-range"></div>';

    readonly link: angular.IDirectiveLinkFn;

    constructor() {
        this.link = this._link.bind(this);
    }

    private _link(
        scope: IYearRangeScope,
        element: JQuery,
        _attributes: angular.IAttributes,
        controller: angular.INgModelController
    ): void {
        scope.change = scope.change || angular.noop;

        // Configure the slider
        const container = angular.element('<div></div>');
        const slider = noUiSlider.create(container[0], this.getOptions(scope));

        // Track any changes a emit via the change handler
        slider.on('change', (_values, _handle, unencodedValues) => {
            scope.model.start = unencodedValues[0];
            scope.model.end = unencodedValues[1];

            scope.change({
                start: scope.model.start,
                end: scope.model.end
            });
        });

        // Append the slider element
        element.append(container);

        // Also watch the model changes to reconfigure the slider
        scope.$watch(
            () => scope.step,
            () => slider.updateOptions(this.getOptions(scope), true)
        );

        scope.$watch(
            () => controller.$modelValue,
            newValue => {
                if (newValue) {
                    slider.set([newValue.start, newValue.end]);
                }
            }
        );
    }

    private getOptions(scope: IYearRangeScope): noUiSlider.Options {
        const min = scope.min;
        const max = scope.max;
        const step = scope.step || 1;
        const range = max - min;

        return {
            connect: true,
            step,
            start: [min, max],
            range: {
                min: [min],
                max: [max]
            },
            pips: {
                mode: 'steps',
                density: (100 / range) * step,
                filter: () => 1, // Always show the large pip number (id = 1)
                format: {
                    to: (year: number) => year - 2000,
                    from: (value: number) => value + 2000
                }
            }
        };
    }
}

const YearRangeDirectiveFactory: angular.IDirectiveFactory = () => new YearRangeDirective();

export { YearRangeDirectiveFactory };
